module.exports = __webpack_public_path__ + "img/nav_home.374830f1.png";